<ng-container *transloco="let t; read: 'tenant-settings'">
  <h2 class="mbm">{{ t("title") }}</h2>
  <form [formGroup]="form" (submit)="onSubmit()" class="grid">
    <kendo-formfield>
      <kendo-label [text]="t('startMorningWorkTime') + ' *'"></kendo-label>
      <kendo-maskedtextbox
        formControlName="startMorningWorkTime"
        [mask]="editMask"
        [includeLiterals]="true"
        [rules]="maskRules"
      >
      </kendo-maskedtextbox>
      <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield>
      <kendo-label [text]="t('endMorningWorkTime') + ' *'"></kendo-label>
      <kendo-maskedtextbox
        formControlName="endMorningWorkTime"
        [mask]="editMask"
        [includeLiterals]="true"
        [rules]="maskRules"
      >
      </kendo-maskedtextbox>
      <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield>
      <kendo-label [text]="t('startAfternoonWorkTime') + ' *'"></kendo-label>
      <kendo-maskedtextbox
        formControlName="startAfternoonWorkTime"
        [mask]="editMask"
        [includeLiterals]="true"
        [rules]="maskRules"
      >
      </kendo-maskedtextbox>
      <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield>
      <kendo-label [text]="t('endAfternoonWorkTime') + ' *'"></kendo-label>
      <kendo-maskedtextbox
        formControlName="endAfternoonWorkTime"
        [mask]="editMask"
        [includeLiterals]="true"
        [rules]="maskRules"
      >
      </kendo-maskedtextbox>
      <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield>
      <kendo-label [text]="t('defaultWorkTime') + ' *'"></kendo-label>
      <kendo-maskedtextbox
        formControlName="defaultWorkTime"
        [mask]="editMask"
        [includeLiterals]="true"
        [rules]="maskRules"
      >
      </kendo-maskedtextbox>
      <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield>
      <kendo-label [text]="t('preliminaryWorktime') + ' *'"></kendo-label>
      <kendo-maskedtextbox
        formControlName="preliminaryWorktime"
        [mask]="editMask"
        [includeLiterals]="true"
        [rules]="maskRules"
      >
      </kendo-maskedtextbox>
      <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield>
      <kendo-label [text]="t('preWorkedHolidayLenght') + ' *'"></kendo-label>
      <kendo-maskedtextbox
        formControlName="preWorkedHolidayLenght"
        [mask]="editMask"
        [includeLiterals]="true"
        [rules]="maskRules"
      >
      </kendo-maskedtextbox>
      <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
    </kendo-formfield>

    <kendo-formfield>
      <kendo-label [text]="t('holidayColor') + ' *'"></kendo-label>
      <kendo-colorpicker formControlName="holidayColor"> </kendo-colorpicker>
      <kendo-formerror>{{ t("isRequiredField") }}</kendo-formerror>
    </kendo-formfield>

    <h3>{{ t('timeSupplements.title') }}</h3>
    <p>{{ t('timeSupplements.description') }}</p>


    <kendo-formfield>
      <kendo-label [text]="t('hasTimeSupplements.label')"></kendo-label>
      <kendo-switch
        formControlName="hasTimeSupplements"
        [onLabel]="t('hasTimeSupplements.true')"
        [offLabel]="t('hasTimeSupplements.false')"
      ></kendo-switch>
    </kendo-formfield>

    @if(form.get('hasTimeSupplements')?.value) {
    <kendo-formfield>
      <kendo-label
        [text]="t('weeklyTimeSupplementPercentage.label')"
      ></kendo-label>
      <kendo-numerictextbox
        formControlName="weeklyTimeSupplementPercentage"
      ></kendo-numerictextbox>
    </kendo-formfield>

    <kendo-formfield>
      <kendo-label
        [text]="t('weeklyMaxWorkTime.label')"
      ></kendo-label>
      <input
        kendoTextBox
        [formControl]="form.get('weeklyMaxWorkTime')"
        placeholder="00:00"
      />

      <kendo-formerror
        *ngIf="
          form.get('weeklyMaxWorkTime')?.hasError('invalidTimeFormat') &&
          form.get('weeklyMaxWorkTime')?.touched
        "
        >{{ t("errors.weeklyMaxWorkTimeInvalid") }}</kendo-formerror
      >
    </kendo-formfield>
    }

    <h3>{{ t('overtime.title') }}</h3>
    <p>{{ t('overtime.description') }}</p>

    <kendo-formfield>
      <kendo-label [text]="t('hasOvertime.label')"></kendo-label>
      <kendo-switch
        formControlName="hasOvertime"
        [onLabel]="t('hasOvertime.true')"
        [offLabel]="t('hasOvertime.false')"
        (valueChange)="onHasOvertimeChange($event)"
      ></kendo-switch>
    </kendo-formfield>

    @if(form.get('hasOvertime')?.value) {
    <kendo-formfield>
      <kendo-label [text]="t('overtimeWeeklyMaxWorkTime.label') + ' *'"></kendo-label>
      <input
        kendoTextBox
        [formControl]="form.get('overtimeWeeklyMaxWorkTime')"
        placeholder="45:00"
      />

      <kendo-formerror
        *ngIf="
          form.get('overtimeWeeklyMaxWorkTime')?.invalid &&
          form.get('overtimeWeeklyMaxWorkTime')?.touched
        "
        >{{ t("errors.overtimeWeeklyMaxWorkTimeInvalid") }}</kendo-formerror
      >
    </kendo-formfield>
    }

    <button
      [disabled]="form.invalid"
      kendoButton
      fillMode="solid"
      size="medium"
      rounded="medium"
      themeColor="primary"
      type="submit"
    >
      {{ t("save") }}
    </button>
  </form>

  <h3 class="mtm">{{ t('recalcTitle') }}</h3>
  <p class="mts mbm">{{ t('recalcDescription') }}</p>
  <button
    kendoButton
    (click)="onRecalculate()"
    loadingIndication="employee/recalculateemployees">
    {{ t('recalculate') }}
  </button>
</ng-container>
